import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { Box, Button, styled } from '@mui/material';
import { FC, PropsWithChildren, useState } from 'react';
import { CustomerLogo, E, StreamVX } from '../../logo';
import { NavigationWidth, getNavigationWidth } from './';

export type NavigationProps = {
  compact?: boolean;
  customerLogoSrc?: string;
};

const NavigationRoot = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  paddingBottom: '10px',
  '.MuiCollapse-root': {
    zIndex: '10',
  },
  '&.Navigation-compact .MuiListItemButton-root > :not(div:first-of-type), &.Navigation-compact .MuiCollapse-root': {
    display: 'none',
  },
  '&.Navigation-compact .NavigationItem-root:hover .MuiCollapse-root': {
    display: 'block',
    position: 'absolute',
    top: 0,
    left: NavigationWidth.Compact,
    width: NavigationWidth.Normal,
    visibility: 'visible',
    height: 'auto!important',
  },
  '&:not(.Navigation-compact) .MuiList-root': {
    overflow: 'hidden auto',
  },
  '& .NavigationItem-root .MuiListItemButton-root > svg:last-of-type': {
    display: 'none',
  },
  '&.Navigation-compact .NavigationItem-root .MuiListItemButton-root > svg:last-of-type': {
    display: 'block',
  },
  '&.Navigation-compact .MuiListSubheader-root': {
    borderBottom: `1px solid ${theme.palette.primary[80]}`,
    fontSize: 0,
  },
  '&.Navigation-compact .MuiCollapse-root .MuiListItemButton-root': {
    paddingLeft: '20px',
  },
  '&.Navigation-compact .Navigation-logo': {
    height: '18px',
  },
  '&.Navigation-compact .Navigation-customerLogo': {
    width: '32px',
    objectFit: 'cover',
    objectPosition: 'top left',
  },
}));

const NavigationHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '60px',
  minHeight: '60px',
  maxHeight: '60px',
  backgroundColor: theme.palette.primary.light,
  marginBottom: '10px',
}));

const CollapseButton = styled(Button)(() => ({
  borderRadius: 0,
  width: '24px',
  padding: 0,
  margin: 0,
  minWidth: '24px',
  boxShadow: 'none',
  height: '100%',
}));

export const Navigation: FC<PropsWithChildren<NavigationProps>> = ({ compact = false, customerLogoSrc, children }) => {
  const [isCompact, setIsCompact] = useState(compact);

  const width = getNavigationWidth(isCompact);
  const onClickHandler = () => setIsCompact(!isCompact);

  return (
    <NavigationRoot
      flexBasis={width}
      width={width}
      minWidth={width}
      maxWidth={width}
      className={isCompact ? 'Navigation-compact' : ''}
    >
      <NavigationHeader>
        {__APP_STYLE__ === 'customer' ? (
          <CustomerLogo src={customerLogoSrc} className="Navigation-customerLogo" />
        ) : isCompact ? (
          <E className="Navigation-logo" height="20px" color="#fff" />
        ) : (
          <StreamVX className="Navigation-logo" height="20px" width="180px" color="#fff" />
        )}
        <CollapseButton variant="contained" color="tertiary" onClick={onClickHandler}>
          {isCompact ? <ArrowRightIcon /> : <ArrowLeftIcon />}
        </CollapseButton>
      </NavigationHeader>
      {children}
    </NavigationRoot>
  );
};
